import React, { useMemo } from 'react';
import { AlertCircle, Plus, Upload } from 'lucide-react';

const BillManagementUI = ({ employeeAddSection, toggleModal, handleUpload, isUploading, formData, employeeBills = [] }) => {
    const billsMissingLocation = useMemo(() => {
        return employeeBills
            .map((bill, index) => (!bill.location ? `Bill ${index + 1}` : null))
            .filter(Boolean);
    }, [employeeBills]);

    const billCount = formData?.length || 0;

    return (
        <div className="bg-gray-800 p-6 rounded-lg shadow-lg max-w-md mx-auto">
            <h2 className="text-2xl font-bold text-white mb-4 text-center">
                Manage Your Bills
            </h2>

            {billsMissingLocation.length > 0 && (
                <div className="mb-4 p-4 bg-blue-900 border-l-4 border-blue-500 text-blue-100 rounded">
                    <div className="flex items-center">
                        <AlertCircle className="h-5 w-5 mr-2" />
                        <p className="font-semibold">Location Pending</p>
                    </div>
                    <p className="mt-2 text-sm">
                        Please add the location for the following bills before uploading:
                    </p>
                    <ul className="list-disc list-inside mt-2 text-sm">
                        {billsMissingLocation.map((bill, index) => (
                            <li key={index}>{bill}</li>
                        ))}
                    </ul>
                </div>
            )}

            <p className="text-gray-300 mb-6 text-center">
                {billCount > 0
                    ? `You have ${billCount} bill${billCount > 1 ? 's' : ''} ready. Add more bills or upload and analyze.`
                    : 'Add your bills, then upload and analyze them.'}
            </p>

            <div className="space-y-4">
                <button
                    onClick={() => { toggleModal(); employeeAddSection(); }}
                    className="w-full px-3 py-2 rounded-md text-gray-800 font-medium
           transition-colors bg-white hover:bg-gray-100
           flex items-center justify-center space-x-2 text-sm"
                    aria-live="polite"
                >
                    <Plus size={16} />
                    <span>Add Another Bill</span>
                </button>
                <button
                    onClick={() => { handleUpload(); toggleModal(); }}
                    disabled={isUploading}
                    className={`w-full px-4 py-3 rounded-md text-white font-semibold
              transition-colors flex items-center justify-center space-x-2
              ${isUploading
                            ? 'bg-gray-500 cursor-not-allowed'
                            : 'bg-green-600 hover:bg-green-700'
                        }`}
                    aria-live="polite"
                >
                    <Upload size={20} />
                    <span>{isUploading ? 'Uploading...' : 'Upload and Analyze'}</span>
                </button>
            </div>
        </div>
    );
};

export default BillManagementUI;
